import { all, select, take } from 'redux-saga/effects';
import { toSuccess } from 'react-async-client';
import { path } from 'ramda';

import { GET_MENU_COUNTERS } from 'constants/actionTypes';
import { getMenuCounters, getUser } from 'actions/asyncActions';
import { pushApprovalNotification } from 'helpers/notificationHelper';
import { countersMapper } from 'mappers/userMapper';
import { getNewNotifications } from 'utils/approvals';

function* menuNotifications() {
    while (true) {
        yield take(GET_MENU_COUNTERS);
        const user = yield select(getUser.selectData);
        const oldState = yield select(getMenuCounters.selectData);
        const state = yield take(toSuccess(GET_MENU_COUNTERS));
        const isServerPush = path(['requestAction', 'payload', 'isPushMessage'], state);

        const newState = yield select(getMenuCounters.selectData);

        const counters = getNewNotifications(countersMapper(oldState, user), countersMapper(newState, user));
        if ((counters.person || counters.project) && !isServerPush) {
            pushApprovalNotification(counters);
        }
    }
}

export default function* menu() {
    yield all([
        menuNotifications()
    ])
}
